import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';

import { RegistrationEdge } from '@app/registration/graph/graph-navigation.service';
import { MarkRegCompleteNode } from '@app/registration/graph/nodes/mark-reg-complete.node';

@Injectable({
  providedIn: 'root',
})
export class MfaToMarkRegCompleteEdge implements RegistrationEdge {
  nextNode = MarkRegCompleteNode;

  shouldNavigate$(): Observable<boolean> {
    return observableOf(true);
  }
}
